export default __webpack_public_path__ + "static/media/Pyramide-besoins_pro_n4_appartenance-verticale.a4f36def.svg";